module.exports = __webpack_public_path__ + "img/home_11.ab64b864.png";